import { render, staticRenderFns } from "./rice_seed.vue?vue&type=template&id=51f9365f&"
import script from "./rice_seed.vue?vue&type=script&lang=js&"
export * from "./rice_seed.vue?vue&type=script&lang=js&"
import style0 from "./rice_seed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports